import { render, staticRenderFns } from "./list.vue?vue&type=template&id=4b16a426&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=4b16a426&prod&lang=less"
import style1 from "./list.vue?vue&type=style&index=1&id=4b16a426&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b16a426",
  null
  
)

export default component.exports